export const Category = {
  RiskMitigation: 'Risk Mitigation',
  StrategicPlanning: 'Strategic Planning',
  FinancialModeling: 'Financial Modeling',
  SalesEnablement: 'Sales Enablement',
  TeamOnboarding: 'Team Onboarding',
  Compliance: 'Compliance',
  Fundraising: 'Fundraising',
  AIToolkits: 'AI Toolkits',
  Forecasting: 'Forecasting'
}

export const mockTools = [
  {
    id: '1',
    title: 'Risk Assessment Framework',
    description: 'A comprehensive framework for identifying, analyzing, and managing business risks. Includes risk matrices, assessment templates, and mitigation strategies.',
    author: 'Risk Management Experts',
    authorId: '1',
    category: Category.RiskMitigation,
    tags: ['Risk Management', 'Compliance', 'Assessment'],
    price: 299.99,
    imageUrl: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    downloads: 1250,
    rating: 4.8,
    files: [
      { name: 'Risk Assessment Template.xlsx', type: 'Excel' },
      { name: 'Risk Matrix.pdf', type: 'PDF' },
      { name: 'Implementation Guide.docx', type: 'Word' }
    ],
    benefits: [
      'Streamlined risk identification process',
      'Comprehensive risk assessment methodology',
      'Ready-to-use templates and matrices',
      'Detailed implementation guidelines'
    ],
    reviews: [
      {
        id: '1',
        userId: 'user1',
        userName: 'Sarah Johnson',
        rating: 5,
        comment: 'This framework has completely transformed how we handle risk assessment. The templates are incredibly well-designed and the implementation guide made it easy to get started.',
        date: '2024-02-15'
      },
      {
        id: '2',
        userId: 'user2',
        userName: 'Michael Chen',
        rating: 4,
        comment: 'Great tool for risk management. The matrices are particularly useful. Would love to see more industry-specific examples in future updates.',
        date: '2024-02-10'
      }
    ]
  },
  {
    id: '2',
    title: 'Strategic Planning Toolkit',
    description: 'A complete toolkit for developing and implementing strategic plans. Includes templates, frameworks, and best practices for strategic planning.',
    author: 'Strategy Consultants',
    authorId: '2',
    category: Category.StrategicPlanning,
    tags: ['Strategy', 'Planning', 'Business Development'],
    price: 199.99,
    imageUrl: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    downloads: 980,
    rating: 4.6,
    files: [
      { name: 'Strategic Plan Template.docx', type: 'Word' },
      { name: 'SWOT Analysis Tool.xlsx', type: 'Excel' },
      { name: 'Strategy Implementation Guide.pdf', type: 'PDF' }
    ],
    benefits: [
      'Proven strategic planning methodology',
      'Comprehensive planning templates',
      'Step-by-step implementation guide',
      'Best practices and case studies'
    ],
    reviews: [
      {
        id: '3',
        userId: 'user3',
        userName: 'David Wilson',
        rating: 5,
        comment: 'This toolkit has been invaluable for our annual strategic planning. The templates are professional and the methodology is sound.',
        date: '2024-02-18'
      },
      {
        id: '4',
        userId: 'user4',
        userName: 'Emily Rodriguez',
        rating: 4,
        comment: 'Very comprehensive toolkit. The SWOT analysis tool is particularly useful. Would recommend to any business looking to improve their strategic planning.',
        date: '2024-02-12'
      }
    ]
  },
  {
    id: '3',
    title: 'Financial Model Builder',
    description: 'A powerful tool for creating detailed financial models. Includes templates for various business scenarios and automated calculations.',
    author: 'Financial Analysts',
    authorId: '3',
    category: Category.FinancialModeling,
    tags: ['Finance', 'Modeling', 'Analysis'],
    price: 399.99,
    imageUrl: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    downloads: 1500,
    rating: 4.9,
    files: [
      { name: 'Financial Model Template.xlsx', type: 'Excel' },
      { name: 'Assumptions Guide.pdf', type: 'PDF' },
      { name: 'User Manual.docx', type: 'Word' }
    ],
    benefits: [
      'Pre-built financial model templates',
      'Automated calculations and formulas',
      'Comprehensive documentation',
      'Scenario analysis capabilities'
    ],
    reviews: [
      {
        id: '5',
        userId: 'user5',
        userName: 'James Thompson',
        rating: 5,
        comment: 'This is the most comprehensive financial modeling tool I\'ve used. The templates are well-structured and the automated calculations save hours of work.',
        date: '2024-02-20'
      },
      {
        id: '6',
        userId: 'user6',
        userName: 'Lisa Anderson',
        rating: 4,
        comment: 'Great tool for financial modeling. The scenario analysis features are particularly useful. Would love to see more industry-specific templates.',
        date: '2024-02-14'
      }
    ]
  },
  {
    id: '4',
    title: 'Sales Enablement Suite',
    description: 'A comprehensive suite of tools for sales teams. Includes playbooks, templates, and training materials.',
    author: 'Sales Experts',
    authorId: '4',
    category: Category.SalesEnablement,
    tags: ['Sales', 'Enablement', 'Training'],
    price: 149.99,
    imageUrl: 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    downloads: 850,
    rating: 4.5,
    files: [
      { name: 'Sales Playbook.pdf', type: 'PDF' },
      { name: 'Proposal Templates.docx', type: 'Word' },
      { name: 'Training Materials.zip', type: 'Archive' }
    ],
    benefits: [
      'Comprehensive sales playbook',
      'Ready-to-use proposal templates',
      'Training and onboarding materials',
      'Best practices and case studies'
    ],
    reviews: [
      {
        id: '7',
        userId: 'user7',
        userName: 'Robert Martinez',
        rating: 5,
        comment: 'This suite has significantly improved our sales process. The playbook is comprehensive and the templates are professional.',
        date: '2024-02-16'
      },
      {
        id: '8',
        userId: 'user8',
        userName: 'Jennifer Lee',
        rating: 4,
        comment: 'Very useful sales enablement tools. The training materials are particularly valuable. Would recommend to any sales team.',
        date: '2024-02-11'
      }
    ]
  },
  {
    id: '5',
    title: 'Team Onboarding System',
    description: 'A structured system for onboarding new team members. Includes checklists, templates, and training materials.',
    author: 'HR Professionals',
    authorId: '5',
    category: Category.TeamOnboarding,
    tags: ['HR', 'Onboarding', 'Training'],
    price: 0,
    imageUrl: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    downloads: 2000,
    rating: 4.7,
    files: [
      { name: 'Onboarding Checklist.xlsx', type: 'Excel' },
      { name: 'Welcome Guide.pdf', type: 'PDF' },
      { name: 'Training Schedule.docx', type: 'Word' }
    ],
    benefits: [
      'Structured onboarding process',
      'Comprehensive checklists',
      'Training and documentation templates',
      'Best practices for team integration'
    ],
    reviews: [
      {
        id: '9',
        userId: 'user9',
        userName: 'Thomas Brown',
        rating: 5,
        comment: 'This system has streamlined our onboarding process significantly. The checklists are thorough and the welcome guide is well-designed.',
        date: '2024-02-19'
      },
      {
        id: '10',
        userId: 'user10',
        userName: 'Amanda White',
        rating: 4,
        comment: 'Great free tool for team onboarding. The training schedule template is particularly useful. Would recommend to any HR team.',
        date: '2024-02-13'
      }
    ]
  },
  {
    id: '6',
    title: 'Compliance Management System',
    description: 'Comprehensive system for managing regulatory compliance.',
    author: 'Compliance Experts',
    authorId: '6',
    category: Category.Compliance,
    tags: ['Compliance', 'Regulations', 'Audit'],
    price: 499.99,
    imageUrl: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    downloads: 750,
    rating: 4.4,
    files: [
      { name: 'Compliance Checklist.xlsx', type: 'Excel' },
      { name: 'Policy Templates.docx', type: 'Word' },
      { name: 'Audit Guide.pdf', type: 'PDF' }
    ],
    benefits: [
      'Automated compliance tracking',
      'Policy management system',
      'Audit preparation tools',
      'Regulatory update alerts'
    ]
  },
  {
    id: '7',
    title: 'Fundraising Toolkit',
    description: 'Complete toolkit for startup fundraising and investor relations.',
    author: 'Fundraising Pro',
    authorId: '7',
    category: Category.Fundraising,
    tags: ['Fundraising', 'Investors', 'Pitch'],
    price: 349.99,
    imageUrl: 'https://images.unsplash.com/photo-1559523161-0fc0d8b38a7a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    downloads: 600,
    rating: 4.3,
    files: [
      { name: 'Pitch Deck Template.pptx', type: 'PowerPoint' },
      { name: 'Financial Projections.xlsx', type: 'Excel' },
      { name: 'Investor Guide.pdf', type: 'PDF' }
    ],
    benefits: [
      'Professional pitch deck templates',
      'Financial projection models',
      'Investor communication tools',
      'Due diligence preparation guides'
    ]
  },
  {
    id: '8',
    title: 'AI Business Toolkit',
    description: 'Collection of AI tools for business automation and analysis.',
    author: 'AI Solutions',
    authorId: '8',
    category: Category.AIToolkits,
    tags: ['AI', 'Automation', 'Analytics'],
    price: 599.99,
    imageUrl: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    downloads: 450,
    rating: 4.2,
    files: [
      { name: 'AI Models.zip', type: 'Archive' },
      { name: 'Implementation Guide.pdf', type: 'PDF' },
      { name: 'API Documentation.pdf', type: 'PDF' }
    ],
    benefits: [
      'Pre-trained AI models',
      'API integration tools',
      'Automation templates',
      'Analytics dashboards'
    ]
  },
  {
    id: '9',
    title: 'Business Forecasting System',
    description: 'Advanced system for business forecasting and trend analysis.',
    author: 'Forecast Pro',
    authorId: '9',
    category: Category.Forecasting,
    tags: ['Forecasting', 'Analytics', 'Trends'],
    price: 449.99,
    imageUrl: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    downloads: 550,
    rating: 4.1,
    files: [
      { name: 'Forecasting Models.xlsx', type: 'Excel' },
      { name: 'Trend Analysis Tool.xlsx', type: 'Excel' },
      { name: 'User Guide.pdf', type: 'PDF' }
    ],
    benefits: [
      'Advanced forecasting algorithms',
      'Trend analysis tools',
      'Scenario modeling',
      'Automated reporting'
    ]
  }
]; 